import { render, staticRenderFns } from "./SleepCard.vue?vue&type=template&id=8c5dd62c&scoped=true"
import script from "./SleepCard.vue?vue&type=script&lang=js"
export * from "./SleepCard.vue?vue&type=script&lang=js"
import style0 from "./SleepCard.vue?vue&type=style&index=0&id=8c5dd62c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5dd62c",
  null
  
)

export default component.exports